import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store'
import VueAxios from 'vue-axios'
import moment from 'moment'

Vue.router = router
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
Vue.config.productionTip = false
Vue.prototype.moment = moment
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
